import { AlertTriangle } from "lucide-react";
import {
    Alert,
    AlertDescription,
    AlertTitle
} from "../ui/alert";

export const LATEST_IMAGE_TAG = "latest";

export const LatestImageTagWarning = () => (
    <Alert variant="warning" className="latest-image-tag-warning">
        <AlertTriangle aria-hidden="true" size={18} />
        <div>
            <AlertTitle>Mutable image tag</AlertTitle>
            <AlertDescription>
                <code>latest</code> can change after this deployment. If Kubernetes recreates the pod later, it may pull a newer image without a new deployment. Choose a specific version for predictable releases.
            </AlertDescription>
        </div>
    </Alert>
);
